export const commodityTypes = {
  product: {
    label: 'Продукт',
    icon: '/icons/model.png',
  },
  part: {
    label: 'Запчасть',
    icon: '/icons/detail.png',
  },
  accessory: {
    label: 'Аксессуар',
    icon: '/icons/accessory.png',
  },
};
